export default __webpack_public_path__ + "static/media/cake-razer-catalog-redeem.8645e7c3.svg";